import React from 'react';
import ImageLink from './ImageLink';
import facebookIcon from '../resources/icon_facebook.png';
import twitterIcon from '../resources/icon_twitter.png';
import discordIcon from '../resources/icon_discord.png';
import emailIcon from '../resources/icon_emailus.png';

const SocialBar: React.FC = () => {
    return (
      <table className="SocialBar">
        <tbody>
          <tr>
            <td className="SocialBarIcon"><ImageLink image={facebookIcon} link="https://www.facebook.com/RhythmHorizon/" /></td>
            <td className="SocialBarIcon"><ImageLink image={twitterIcon} link="https://twitter.com/rhythmhorizon" /></td>
            <td className="SocialBarIcon"><ImageLink image={discordIcon} link="https://discord.gg/CTFAnjx" /></td>
            <td className="SocialBarIcon"><ImageLink image={emailIcon} link="mailto:lara@welovelama.com" /></td>
          </tr>
        </tbody>
      </table>
    );
  }
  
  export default SocialBar;